import { Flex, Td, Tr } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { AiFillCopy } from 'react-icons/ai'
import { formatPrice } from '../../../utils/formatPrice'
import { format } from 'date-fns'
import { cnpjMask } from '../../../utils/cnpjMask'

export function ControleItem({ item }) {
  const [isCopy, setIsCopy] = useState(false)

  function copyKeyToClipboard() {
    navigator.clipboard.writeText(item.chave_acesso)

    setIsCopy(true)
  }

  useEffect(() => {
    if (isCopy) {
      setTimeout(() => {
        setIsCopy(false)
      }, 3000)
    }
  }, [isCopy])

  if (!item) return null

  return (
    <Tr key={item.id}>
      <Td>{item.numero_unico}</Td>
      <Td>{item.numero_nfe}</Td>
      <Td>{item.numero_pedido}</Td>
      <Td>{format(new Date(item?.data_emissao), 'dd/MM/yyyy HH:mm')}</Td>
      <Td>{format(new Date(item?.data_saida), 'dd/MM/yyyy HH:mm')}</Td>
      <Td>{cnpjMask(item.cnpj_remetente)}</Td>
      <Td textTransform="capitalize">{item.razao_social?.toLowerCase()}</Td>
      <Td>{cnpjMask(item.cnpj_cliente)}</Td>
      <Td textTransform="capitalize">
        {item.razao_social_cliente?.toLowerCase() ?? 'Não informaßdo'}
      </Td>

      <Td>{item.estado_origem}</Td>
      <Td>{item.estado_cliente}</Td>
      <Td>{item.cliente_entrega_estado_destino || 'Não informado'}</Td>
      <Td>{item.cliente_entrega_cnpj || 'Não informado'}</Td>
      <Td>{item.cliente_entrega_inscricaoest ?? 'Não informado'}</Td>
      <Td>{item.codigo_produto}</Td>
      <Td>{item.cfpo}</Td>
      <Td>{item.ncm}</Td>
      <Td>{item.cest}</Td>

      <Td>{formatPrice(item.valor_unitario)}</Td>
      <Td>{item.quantidade_negociada}</Td>
      <Td>{formatPrice(item.valor_total)}</Td>

      <Td>{formatPrice(item.base_icms)}</Td>
      <Td>{formatPrice(item.valor_icms)}</Td>
      <Td>{formatPrice(item.base_subs_tit)}</Td>
      <Td>{formatPrice(item.vlr_subs_tit)}</Td>
      <Td>{formatPrice(item.base_ipi)}</Td>
      <Td>{formatPrice(item.vlr_ipi)}</Td>
      <Td>{formatPrice(item.vlr_frete)}</Td>
      <Td>{item.nota_xml ?? 'Não informado'}</Td>

      <Td>
        <Flex
          gap="2"
          alignItems="center"
          cursor="pointer"
          onClick={() => copyKeyToClipboard()}
        >
          {!isCopy ? 'Copiar' : 'Copiado'} <AiFillCopy />{' '}
        </Flex>
      </Td>
    </Tr>
  )
}
